export function redirectToAuthPage({
  isPageInAppView
}: {
  isPageInAppView: boolean
}) {
  if (isPageInAppView) {
    window.location.href = '/next-profile/login?return-url=/vip'
  } else {
    window.location.href = '/home/join?flow=register&redirecturl=/vip'
  }
}

export function onVipButtonClick() {
  window.location.href =
    '/home/join/?flow=authenticate&redirecturl=/next-profile/profile?tab=vip_family'
}
